import { Controller } from '@hotwired/stimulus';

/** Single membership card: flip between yearly (default) and monthly on /pricing */
export default class extends Controller {
  static targets = [
    'card',
    'track',
    'pill',
    'switch',
    'yearlyPanel',
    'monthlyPanel',
    'popularBadge',
    'yearlyCta',
    'monthlyCta',
  ];

  static values = {
    plan: { type: String, default: 'yearly' },
    useCheckout: { type: Boolean, default: false },
  };

  connect() {
    this.show(this.planValue);
  }

  toggle() {
    this.planValue = this.planValue === 'yearly' ? 'monthly' : 'yearly';
  }

  planValueChanged() {
    this.show(this.planValue);
  }

  show(plan) {
    const yearly = plan === 'yearly';

    if (this.hasTrackTarget) {
      this.trackTarget.dataset.plan = plan;
    }

    if (this.hasCardTarget) {
      this.cardTarget.dataset.plan = plan;
    }

    this.yearlyPanelTarget.classList.toggle('is-active', yearly);
    this.yearlyPanelTarget.toggleAttribute('inert', !yearly);
    this.yearlyPanelTarget.setAttribute('aria-hidden', yearly ? 'false' : 'true');

    this.monthlyPanelTarget.classList.toggle('is-active', !yearly);
    this.monthlyPanelTarget.toggleAttribute('inert', yearly);
    this.monthlyPanelTarget.setAttribute('aria-hidden', yearly ? 'true' : 'false');

    if (this.hasPopularBadgeTarget) {
      this.popularBadgeTarget.classList.toggle('is-hidden', !yearly);
      this.popularBadgeTarget.setAttribute('aria-hidden', yearly ? 'false' : 'true');
    }

    if (this.hasSwitchTarget) {
      const next = yearly ? 'monthly' : 'yearly';
      this.switchTarget.setAttribute(
        'aria-label',
        `Billing period: ${yearly ? 'Yearly' : 'Monthly'}. Activate to switch to ${next}.`
      );
    }

    this.updateCtas(yearly);
  }

  updateCtas(yearly) {
    if (this.hasYearlyCtaTarget) {
      this.yearlyCtaTarget.classList.toggle('hidden', !yearly);
    }

    if (this.hasMonthlyCtaTarget) {
      this.monthlyCtaTarget.classList.toggle('hidden', yearly);
    }

    if (!this.useCheckoutValue) return;

    const links = [
      this.hasYearlyCtaTarget ? this.yearlyCtaTarget.querySelector('a') : null,
      this.hasMonthlyCtaTarget ? this.monthlyCtaTarget.querySelector('a') : null,
    ].filter(Boolean);

    links.forEach((link) => {
      link.dataset.turbo = 'false';
    });
  }
}
